/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterISmall = createReactComponent("outline", "letter-i-small", "IconLetterISmall", [["path", { "d": "M12 8v8", "key": "svg-0" }]]);

export { IconLetterISmall as default };
//# sourceMappingURL=IconLetterISmall.mjs.map
